// Initialize Sentry first (will only load on production/staging)
import "./instrument";
import "./index.css";
import { createRoot } from 'react-dom/client';

import App from './App';

// Disable React Error Overlay in development
if (process.env.NODE_ENV === 'development') {
  // Override the error event to prevent React error overlay
  window.addEventListener('error', (event) => {
    event.stopImmediatePropagation();
  });

  // Add CSS to hide React error overlay
  const style = document.createElement('style');
  style.innerHTML = `
    iframe[src*="react-error-overlay"],
    iframe[title="React Error Overlay"],
    div[id*="react-error-overlay"],
    div[data-react-error-overlay] {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      pointer-events: none !important;
      z-index: -1 !important;
    }
  `;
  document.head.appendChild(style);
}

const container = document.getElementById('root');

if (!container) {
	throw new Error('No container found');
}

// Remove initial loader when React loads
const initialLoader = document.getElementById('initial-loader');
if (initialLoader) {
	initialLoader.remove();
}

const root = createRoot(container);
root.render( <App />);